import { useNavigate } from "react-router-dom"
import routes from "routes"
import { BROWSER_STORAGE_KEYS } from "utils/constants"
import { UserPreferenceManager } from "utils/userPreferenceManager"

import { SpnyTourEnum, SpnyTourType } from "../Context"
import ResumeTourBox from "../ResumeTourBox"
import { useTourContext } from "../TourProvider"

const ResumeAIToolsTour = ({
  onClose,
  onContinue,
}: {
  onContinue: () => void
  onClose: () => void
}) => {
  const { step } = useTourContext()
  const spnyAiToolsTour = UserPreferenceManager.get(
    BROWSER_STORAGE_KEYS.spnyAiTools
  ) as SpnyTourType
  const navigate = useNavigate()

  if (spnyAiToolsTour === SpnyTourEnum.initiated && !step) {
    return (
      <ResumeTourBox
        title="Take a quick tour of the AI Tools Tab?"
        subTitle="Get a quick overview of how to use AI tools here."
        onContinue={() => {
          navigate(routes.aiTools.home)
          onContinue()
        }}
        onClose={onClose}
      />
    )
  }
  return null
}

export default ResumeAIToolsTour
